import React from 'react';
import { Card } from '@mts/ui';
import { Flag, Pencil } from 'lucide-react';

function BasicAboutUsCard({ description, listingMeta = null, canEdit = false, onEdit }) {
  const descriptionText = typeof description === 'string' ? description.trim() : '';
  const meta = listingMeta && typeof listingMeta === 'object' && !Array.isArray(listingMeta)
    ? listingMeta
    : {};
  const showGenerativeSummaryAttribution = meta.googleGenerativeSummaryUsed === true
    && typeof meta.googleGenerativeSummaryFlagContentUri === 'string'
    && meta.googleGenerativeSummaryFlagContentUri.trim();
  const disclosureText = typeof meta.googleGenerativeSummaryDisclosureText === 'string' && meta.googleGenerativeSummaryDisclosureText.trim()
    ? meta.googleGenerativeSummaryDisclosureText.trim()
    : 'Summarized with Gemini';

  return (
    <div id="AboutUsCard">
      <Card
        id="AboutUsCard-Card"
        className="my-[10px] rounded-lg"
        style={{
          backgroundColor: 'var(--card)',
          borderColor: 'var(--border)',
          borderWidth: '1px',
          borderStyle: 'solid',
        }}
      >
      <Card.Header id="AboutUsCard-CardHeader" className="flex items-start justify-between gap-3">
        <div id="AboutUsCard-CardHeaderInner">
          <h2 className="text-base font-semibold text-[var(--primary)]">About Us</h2>
          <Card.Title id="AboutUsCard-CardTitle">
            <span className="sr-only">About this business</span>
          </Card.Title>
          <Card.Description id="AboutUsCard-CardDescription">
            <span className="sr-only">Business description section</span>
          </Card.Description>
        </div>
        <Card.Action id="AboutUsCard-CardAction">
          {canEdit ? (
            <button
              type="button"
              aria-label="Edit About Us"
              title="Edit About Us"
              onClick={onEdit}
              className="inline-flex h-9 w-9 items-center justify-center rounded-md border border-[var(--border)] text-[var(--primary)] transition-colors hover:bg-black/5 focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--primary)]/30"
            >
              <Pencil size={16} aria-hidden="true" />
            </button>
          ) : (
            <div />
          )}
        </Card.Action>
      </Card.Header>

      <Card.Content
        id="AboutUsCard-CardContent"
        className="before:content-none after:content-none"
      >
        {descriptionText ? (
          <p className="text-sm leading-6 text-black/80">{descriptionText}</p>
        ) : (
          <p className="text-sm leading-6 text-black/65">No business description has been added yet.</p>
        )}
        {showGenerativeSummaryAttribution ? (
          <div className="mt-4 flex flex-wrap items-center gap-3 border-t border-[var(--border)] pt-3 text-xs text-black/60">
            <span>{disclosureText}</span>
            <a
              href={meta.googleGenerativeSummaryFlagContentUri}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-1.5 rounded-md border border-[var(--border)] px-2 py-1 font-medium text-[var(--primary)] hover:bg-black/5"
            >
              <Flag size={13} />
              Flag content
            </a>
          </div>
        ) : null}
      </Card.Content>

      <Card.Footer id="AboutUsCard-CardFooter">
        <div />
      </Card.Footer>
      </Card>
    </div>
  );
}

export default BasicAboutUsCard;
